import {actions} from './actions';
import {getters} from './getters';
import {mutations} from './mutations';
import {state} from './state';

// Export article store
export const article = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
